import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  //policyDetailsGlobal: [],
  lendersLst: [],
  lendersListFirmOnly: [],
  savedLenderDetails: null,
};

// our slice
const lenderSlice = createSlice({
  name: "lenders",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setLenderList: (state, { payload }) => {
      state.lendersLst = payload;
    },
    setLenderListFirmOnly: (state, { payload }) => {
      state.lendersListFirmOnly = payload;
    },
    setSavedLenderDetails: (state, { payload }) => {
      state.loading = false;
      state.savedLenderDetails = payload;
    },
  },
});

// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setLenderList,
  setLenderListFirmOnly,
  setSavedLenderDetails,
} = lenderSlice.actions;

export const lenderSelector = (state) => state.lenders;

// export the default reducer
export default lenderSlice.reducer;

export const GetLenders = (userName, fileID, firmID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      UserName: userName,
      FileID: fileID,
      FirmId: firmID
    };

    const results = await http.post("Lender/GetLenders", req).then((result) => {
      return result;
    });

    if (results.data.responseCode == 0) {
      dispatch(setLenderList(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetLendersPublic = (FirmID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      UserName: "",
      FirmId: FirmID,
    };

    const results = await http
      .post("Lender/GetLendersPublic", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setLenderList(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetLendersFirmOnly = (FirmID, IsActive) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      FirmId: FirmID,
      IsActive: IsActive,
    };

    const results = await http
      .post("Lender/GetLendersFirmOnly", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setLenderListFirmOnly(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const SaveLender = (request, decision, userName) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const results = await http
      .post("Lender/SaveLender", request)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(GetLenders(userName, request?.FileID, request?.FirmID)).then((result) => {
        dispatch(GetLendersFirmOnly(request?.FirmID, true)).then((resutl1) => {
          results.data.responseObject.decision = decision;
          dispatch(setSavedLenderDetails(results.data.responseObject));
        });
      });
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
